import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";

@Component({
  selector: 'brt-organization-trophies-overlay-footer',
  templateUrl: './organization-trophies-overlay-footer.component.html',
  styleUrls: ['./organization-trophies-overlay-footer.component.scss']
})
export class OrganizationTrophiesOverlayFooterComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
}
